import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SegmentSearchFilterModel} from './search/search-filter.model';
import {ExportPreviewDialogComponent, ExportPreviewDialogData} from './export/export-preview-dialog.component';
import {SegmentFacadeService} from '../segment-facade.service';
import {flattenToSegments} from '../segments.state';
import {Segment} from '../segment.model';
import {ApiVersion} from '../../app.types';
import {Page} from '../../components/common-interfaces';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportPreparerService {

  private segmentsForExportLoadedNotifier$: Subject<Segment[]> = new Subject<Segment[]>();

  constructor(private dialog: MatDialog,
              private segmentsFacade: SegmentFacadeService
  ) {
  }

  listenToSegmentsForExport(): Observable<Segment[]> {
    return this.segmentsForExportLoadedNotifier$.asObservable();
  }

  prepareExportPreview(searchFormValues: SegmentSearchFilterModel, apiVersion: ApiVersion) {
    this.segmentsFacade.loadSegmentsForExportPreview(searchFormValues, apiVersion);
  }

  fetchAllSegmentsToExport(searchFormValues: SegmentSearchFilterModel, apiVersion: ApiVersion) {
    this.segmentsFacade.loadSegmentsForExport(searchFormValues, apiVersion);
  }

  openDialog(segments: Page<Segment>, filterSearchValues: SegmentSearchFilterModel, apiVersion: ApiVersion) {
    let title = 'Segments ' + new Date().toLocaleString('de', {timeZoneName: 'short'})
      .replace(/ CET/, '');
    let titleQualifier = '';
    if (filterSearchValues.category?.length) {
      titleQualifier += ' categories: ' + filterSearchValues.category.join(', ');
    }
    if (filterSearchValues.segmentMainTypes?.length) {
      titleQualifier += ' types ' + filterSearchValues.segmentMainTypes.join(', ');
    }
    if (filterSearchValues.accounts?.length) {
      titleQualifier += ' accounts ' + filterSearchValues.accounts.map(acc => acc.description).join(', ');
    }
    title += titleQualifier || ' all';
    const filteredSegments = this.extractSegments(filterSearchValues, segments);

    this.dialog.open(ExportPreviewDialogComponent, {
      width: '1000px',
      data: <ExportPreviewDialogData>{
        title,
        segments: filteredSegments,
        segmentsTotalPageCount: segments.totalElements,
        previousFilter: filterSearchValues,
        apiVersion
      }
    });
  }

  notifyExportValues(segments: Page<Segment>, filterSearchValues: SegmentSearchFilterModel) {
    const filteredSegments = this.extractSegments(filterSearchValues, segments);

    this.segmentsForExportLoadedNotifier$.next(
      filteredSegments
    );
  }

  private extractSegments(filterSearchValues: SegmentSearchFilterModel, segments: Page<Segment>) {
    const flattenedSegments = flattenToSegments(segments.content);
    if (!filterSearchValues.accounts?.length) {
      return flattenedSegments;
    }
    return flattenedSegments.map((s: Segment) => {
      const segment = Object.assign({}, s);
      segment.sharedAccounts = segment.sharedAccounts.filter((a: number) => filterSearchValues.accounts?.find(fa => fa.id === a));
      return segment;
    });
  }
}
